import * as Sentry from '@sentry/react';

import { ERROR_CODES, hasErrorCode } from '@/core/api';
import { CREDENTIALS_MISSING_MESSAGE } from '@/core/apiErrorMessages';

/**
 * The copy to show when a password login's createToken reached the api with no
 * credentials, or undefined for any other error (ENG-5831).
 *
 * The visitor's network stripped the Authorization header, so it is reported as
 * a warning: an outcome we cannot fix but still want to count, not a bug. The
 * fingerprint keeps every login form's report in one issue, apart from the
 * genuinely unknown errors that share these stack frames.
 */
export function handleCredentialsMissing(err: unknown): string | undefined {
  if (!hasErrorCode(err, ERROR_CODES.AUTH_CREDENTIALS_MISSING)) return undefined;
  Sentry.captureException(err, {
    level: 'warning',
    tags: { login_failure: 'credentials_missing' },
    fingerprint: [ERROR_CODES.AUTH_CREDENTIALS_MISSING],
  });
  return CREDENTIALS_MISSING_MESSAGE;
}
